export const Icon = () => {
    return (
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="#ffffff">
            <path d="M20 12H4" strokeLinecap="round" />
            <path d="M12 4V20" strokeLinecap="round" />
        </svg>
    );
};
